import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
// 路由数据
import routes from './routes'
import util from '@/libs/util'
import lenye_base from 'lenye_base'
import {
	Message
} from 'element-ui'

Vue.use(VueRouter)

// const authUrl = process.env.VUE_APP_LYAI_AUTH
const authUrl = "//" + window.location.host
const isloginurl = "https://portal." + lenye_base.url.gettopUrl();
// 导出路由 在 main.js 里使用
const router = new VueRouter({
	mode: 'history',
	routes
})

const authorization = process.env.VUE_APP_CLOUD_AUTHORIZATION

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
	// 验证当前路由所有的匹配中是否需要有登录验证的

	if (to.query.access_token !== undefined) {
		next()
		return
	}
	if (authorization === 'open' && to.path === "/login" && to.query.code === undefined) {
		return new Promise(() => {
			let Logincode = lenye_base.login_third.init(
				function() {}, {
					isLoginUrl: isloginurl + '/auth/isLogin',
					type: 'islogin',
					redirectUrl: window.location.href
				})
			if (Logincode && Logincode.code && Logincode.state) {
				let ssoLoginData = lenye_base.httpGetSynct(authUrl +
					'/usercenter-service/login/oauth2/code/sso-login?siteId=' + lenye_base
					.site_data
					.getsiteData().siteId + '&code=' + encodeURIComponent(Logincode.code) +
					'&state=' +
					encodeURIComponent(Logincode.state));
				if (ssoLoginData.success === "1") {
					lenye_base.user_data.setuserData(ssoLoginData.data);
					store.dispatch('system/account/loginByUserinfo', ssoLoginData.data).then(() => {
						next({
							path: '/index'
						})
					})
					return
				} else {
					next()
				}
			} else {
				next()
			}
		}).catch(() => {
			next()
		})
	}
	if (authorization === 'open' && to.path === "/login" && to.query.code !== undefined) {
		return new Promise(() => {
			let Logincode = lenye_base.login_third.init(
				function() {}, {
					isLoginUrl: isloginurl + '/auth/isLogin',
					type: 'islogin',
					redirectUrl: window.location.href
				})
			Logincode.code = to.query.code
			Logincode.state = to.query.state

			if (Logincode && Logincode.code && Logincode.state) {
				let ssoLoginData = lenye_base.httpGetSynct(authUrl +
					'/usercenter-service/login/oauth2/code/sso-login?siteId=' + lenye_base
					.site_data
					.getsiteData().siteId + '&code=' + encodeURIComponent(Logincode.code) +
					'&state=' +
					encodeURIComponent(Logincode.state));
				if (ssoLoginData.success === "1") {
					lenye_base.user_data.setuserData(ssoLoginData.data);
					store.dispatch('system/account/loginByUserinfo', ssoLoginData.data).then(() => {
						next({
							path: '/index'
						})
					})
					return
				} else {
					next()
				}
			} else {
				next()
			}
		}).catch(() => {
			next({
				path: '/login'
			})
		})
	}

	// if (to.path === "/login" && to.query.code !== undefined) {
	// 	// 没有登录的时候跳转到登录界面
	// 	// 携带上登陆成功之后需要跳转的页面完整路径
	// 	await store.dispatch('system/account/login_by_code', to.query)
	// 	let fillPath = util.cookies.get(to.query.state)
	// 	util.cookies.remove(to.query.state)
	// 	next({
	// 		path: !fillPath ? '/index' : fillPath
	// 	})
	// 	return
	// }
	if (to.matched.some(r => r.meta.auth)) {
		// 证是否登录的条件
		// 请根据自身业务需要修改
		const token = util.cookies.get('access_token')
		const isSigned = store.getters['system/account/isSigned']
		if (isSigned || (token && token !== 'undefined')) {
			await store.dispatch('system/account/load')
			if (to.meta.authority) {
				if (store.getters['system/account/hasOneAuthoritiy'](to.meta.authority)) {
					next()
				} else {
					Message({
						message: "您无权访问此页面，自动跳转至首页！",
						type: 'error',
						duration: 1000
					})
					next({
						path: '/'
					})
				}
			} else {
				next()
			}
		} else {
			await store.dispatch('system/account/loginByLyai')
			next()
		}
	} else {
		// 不需要身份校验 直接通过
		next()
	}
})

router.afterEach(to => {
	// 更改标题
	util.title(to.meta.title)
})


export default router
